'use client'
import styles from './DiscSignalsTooltip.module.scss'
import useDiscSignalCounts from '@crystal-eyes/hooks/profiles/useDiscSignalCounts'
import usePersonalInfo from '@crystal-eyes/hooks/profiles/usePersonalInfo'
import Icon, { Icons } from '@crystal-eyes/components/elements/Icon/Icon'

interface Identity {
  id: string
}

export default function DiscSignalsTooltip({
  identity,
}: {
  identity?: Identity
}) {
  const { data: personalInfo } = usePersonalInfo({ identity })
  const { data: signalsUsed } = useDiscSignalCounts({ identity })

  if (!signalsUsed || !personalInfo) return null
  const total = signalsUsed.D + signalsUsed.I + signalsUsed.S + signalsUsed.C

  return (
    <span
      className={`${styles.discSignalsTooltip} CE tooltip bottom-left-tooltip`}
    >
      <Icon icon={Icons.Info} className={`${styles.icon}`} />
      <div className="CE signal-data tooltip-content">
        <span className="intro">
          Crystal found {total} personality signals for {personalInfo.firstName}
          :
        </span>

        <ul>
          <li>
            {signalsUsed.D}&nbsp;
            <span className="signal-disc-category CE disc-color D">
              Dominant
            </span>
            signals
          </li>
          <li>
            {signalsUsed.I}&nbsp;
            <span className="signal-disc-category CE disc-color I">
              Influential
            </span>
            signals
          </li>
          <li>
            {signalsUsed.S}&nbsp;
            <span className="signal-disc-category CE disc-color S">Steady</span>
            signals
          </li>
          <li>
            {signalsUsed.C}&nbsp;
            <span className="signal-disc-category CE disc-color C">
              Conscientious
            </span>
            signals
          </li>
        </ul>
      </div>
    </span>
  )
}
